
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import SEO from './components/common/SEO';
import Hero from './components/sections/Hero';
import About from './components/sections/About';
import Services from './components/sections/Services';
import Process from './components/sections/Process';
import Gallery from './components/sections/Gallery';
import Contact from './components/sections/Contact';
import Footer from './components/layout/Footer';
import LegalPage from './components/pages/LegalPage';
import legalContent from './data/legalContent.json';

// A component to encapsulate the home page content
function Home() {
  return (
    <>
       <SEO /> 
      <Hero />

      {/* Temporary placeholders for sections to allow scrolling */}
      <About />
      <Services />
      <Process />
      <Gallery />
      <Contact />
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="bg-secondary-cream min-h-screen font-sans antialiased text-gray-900 selection:bg-accent-gold selection:text-white">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/kvkk" element={<LegalPage title={legalContent.kvkk.title} content={legalContent.kvkk.content} />} />
          <Route path="/gizlilik-politikasi" element={<LegalPage title={legalContent.privacy.title} content={legalContent.privacy.content} />} />
          <Route path="/cerez-politikasi" element={<LegalPage title={legalContent.cookies.title} content={legalContent.cookies.content} />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

